var _effectorFileName = "/src/page-content/cases/ui.tsx";
import { useTranslation } from 'next-i18next';
import { MainLayout } from '@/widgets/layouts/main';
import { PageSeo } from '@/shared/lib/seo';
import { CasesBlock } from './components/cases-block';
import { Main } from './components/main';
export const CasesPage = () => {
  const {
    t
  } = useTranslation('cases-page');
  return <>
      <PageSeo title={t('seo.title')} description={t('seo.description')} />

      <Main />

      <CasesBlock />
    </>;
};
CasesPage.Layout = MainLayout;